import Home from './components/Home'
import Customize from './components/Customize'
import Login from './components/Login'
import SignUp from './components/SignUp'
import NewTheme from './components/NewTheme'
import UserSite from './components/UserSite'
// import AuthGuard from './auth-guard'

export const routes = [
  {
    path: '/',
    name: 'Home',
    components: {
      default: Home
    }
  },
  // {
  //   path: '*',
  //   redirect: '/'
  // },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/sign-up',
    name: 'SignUp',
    component: SignUp
  },
  {
    path: '/customize/:theme_id/',
    name: 'Customize',
    component: Customize
    // beforeEnter: AuthGuard
  },
  // {
  //   path: '/:user_theme_slug/',
  //   name: 'UserSite',
  //   component: UserSite
  // },
  {
    path: '/add',
    name: 'Add Theme',
    component: NewTheme
    // beforeEnter: AuthGuard
  }
]


// WEBPACK FOOTER //
// ./src/routes.js